export default __webpack_public_path__ + "static/media/asaas.alt.15aa7c9c.png";